import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../SharedStyles.css';

const HamburgerMenu = () => {
  const navigate = useNavigate();

  return (
    <div className="hamburger-menu">
      {/* Home Logo */}
      <img
        src="/assets/images/solana_1_dollar_stable_memecoin_270x248px.png"
        alt="Home"
        className="home-logo"
        onClick={() => navigate('/')}
      />

      {/* Hamburger Icon */}
      <input type="checkbox" id="menu-toggle" />
      <label htmlFor="menu-toggle" className="menu-icon">
        <div></div>
        <div></div>
        <div></div>
      </label>

      {/* Menu Items */}
      <nav className="menu-items">
        <ul>
          <li onClick={() => navigate('/about')}>About</li>
          <li onClick={() => navigate('/faq')}>FAQ</li>
          <li onClick={() => navigate('/roadmap')}>Roadmap</li>
          <li onClick={() => navigate('/storyline')}>Storyline</li>
          <li onClick={() => navigate('/characters')}>Characters</li>
        </ul>
      </nav>
    </div>
  );
};

export default HamburgerMenu;
